export default {
    data () {
        return {
            modalParams: {},
            activeModal: null
        };
    },
    methods: {
        reportComment: function (commentId) {
            this.modalParams = {
                reportableId: commentId,
                reportable: 'comment_id',
                title: 'Report comment',
                reasons: ['Spam', 'Violates Community Guidelines']
            };
            this.activeModal = 'report-modal';
        },
        deactivateModal: function() {
            this.activeModal = null;
        }
    },
    mounted: function () {
        var self = this;
        this.$eventHub.$on('reportComment', function(comment) {
            self.reportComment(comment.id);
        });
    }
}
